import * as KeyboardPlugin from '@capacitor/keyboard';
import { isPlatform } from '@ionic/react';

const Keyboard = isPlatform('hybrid') ? KeyboardPlugin.Keyboard : null;

export default Keyboard;
